import listActions from 'src/modules/company/list/companyListActions';
import CompanyService from 'src/modules/company/companyService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'COMPANY_DESTROY';

const companyDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: companyDestroyActions.DESTROY_STARTED,
      });

      await CompanyService.destroyAll([id]);

      dispatch({
        type: companyDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.company.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/company');
    } catch (error) {
      Errors.handle(error, 'destroy');

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: companyDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: companyDestroyActions.DESTROY_ALL_STARTED,
      });

      await CompanyService.destroyAll(ids);

      dispatch({
        type: companyDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.company.destroyAll.success'),
      );

      getHistory().push('/company');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: companyDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default companyDestroyActions;
